/**
 * 退费流程
 * */
export var refundProcessNew = 'refundWorkOrderNewProcess';

/**
 *配送
 * */
export var distributionWorkOrderProcess = 'distributionWorkOrderProcess';